import clearKey from './clearKey'

export const clearFailed = clearKey('failed')

export default clearFailed
